import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const HierarchyLayout = lazy(() => import('@/pages/hierarchy/layout'));
const HierarchyPage = lazy(() => import('@/pages/hierarchy'));

/**
 * The hierarchy tree is reached only as `/hierarchy/:versionId`, from the "Hierarchy" card of a
 * version's detail page; there is deliberately no bare `/hierarchy` route.
 */
export const hierarchyRoutes: RouteConfig = {
  path: '/hierarchy',
  layout: DashboardLayout,
  children: [{ path: '/:versionId', layout: HierarchyLayout, element: HierarchyPage }],
};
